import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Container.scss'

const Container = ({
  children, className, topPadding, large,
}) => (
  <div className={classnames(styles.container, className, { [styles.topPadding]: topPadding }, { [styles.large]: large })}>
    {children}
  </div>
)

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  large: PropTypes.bool,
  topPadding: PropTypes.bool,
}

Container.defaultProps = {
  children: null,
  className: null,
  large: false,
  topPadding: false,
}

export default Container



// WEBPACK FOOTER //
// ./src/components/layout/Grid/Container/Container.js